import { Injectable } from '@angular/core';
import { FallbackComponent } from '../../dynamic-content/fallback/fallback.component';
import { RawHtmlComponent } from '../../dynamic-content/raw-html/raw-html.component';

export interface ComponentInfo {
    exportName?: string;
    component?: any;
    loader?: () => Promise<any>;
    isLoaded?: boolean;
    loadedEsModule?: any;
}

const contentItemComponentMap = new Map<string, ComponentInfo>([
    // PRELOADED components
    ['__fallback__', { component: FallbackComponent }],
    ['componentRawHtml', { component: RawHtmlComponent }]
    ////////////////////
]);

@Injectable({
    providedIn: 'root'
})
export class ContentItemTypeMapService {
    getMap() {
        return contentItemComponentMap;
    }
}
